<template>
  <div class="version-list-item">
    <div
      class="event-icon text-white"
      :class="{
        'bg-success': version.event === 'Criação',
        'bg-danger':  version.event === 'Exclusão',
        'bg-info':    version.event === 'Atualização',
      }"
    >
      <i v-if="version.event === 'Exclusão'"         class="fa fa-trash"></i>
      <i v-else-if="version.event === 'Atualização'" class="fa fa-pen"></i>
      <i v-else-if="version.event === 'Criação'"     class="fa fa-plus"></i>
    </div>


    <div class="event-content">
      <span class="h5 pt-1">{{ version.created_at }}</span>
      <span class="h5 pl-3 pt-1 text-muted">{{ version.event }} de {{ version.item_type }} [{{ version.item_id }}]</span>
      </br>
      <div v-if="version.user_name">
        <span class="h5 pl-1 pt-1">Autor:</span>
        <span class="h5 pl-3 pt-1 text-muted">{{ version.user_name }}</span>
        <br>
      </div>
      <div v-if="version.item_type === 'Meta'">
        <span class="h5 pl-1 pt-1">Grupo:</span>
        <span class="h5 pl-3 pt-1 text-muted">{{ version.custom_data.group_name || 'Sem Grupo' }}</span>
        <br>
      </div>
      <div v-if="version.item_type === 'Produto preferencial'">
        <span class="h5 pl-1 pt-1">Grupo:</span>
        <span class="h5 pl-3 pt-1 text-muted">{{ version.custom_data.grupo_name || 'Sem Grupo' }}</span>
        <br>
      </div>
      <div v-if="version.custom_data.preferredproduct_name || version.custom_data.name">
        <span class="h5 pl-1 pt-1">Produto:</span>
        <span class="h5 pl-1 pt-1 text-muted">{{ version.custom_data.preferredproduct_name || version.custom_data.name }}</span>
      
        </br>
      </div>
        </br>
      <div class="changes">
        <div
          v-for="(change, key) in version.changes_to_json"
          :key="key"
          class="row p-0 mb-0 align-items-center justify-content-between change"
          style="width: 100%;"
        >
          <div class="col">
            {{ key }}
          </div>
          <div class="col">
            {{ formatValue(change[0], key) }}
          </div>
          <i class="fa fa-arrow-right text-muted"></i>
          <div class="col">
            {{ formatValue(change[1], key) }}
          </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps(['version']);

const formatValue = (value, key) => {
  if (value === null) {
    return '[VAZIO]';
  }

  if (value instanceof Number || typeof value === 'number' || (typeof value === 'string' && value.match(/^\d+(\.\d+)?$/) !== null)){
    if (key.match(/valor|meta|pre[çc]o/i) !== null) {
      return parseFloat(value).toLocaleString('pt-BR', {style: 'currency', currency: 'brl', minimumFractionDigits: 2, maximumFractionDigits: 2});
    }

    return parseFloat(value).toLocaleString('pt-BR');
  }

  return value;
};
</script>

<style scoped>
.version-list-item {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: start;
  padding-bottom: 12px;
  border-left: 2px solid #eee;
  padding-left: 25px;
}

.version-list-item .event-icon {
  position: absolute;
  left: -16px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.version-list-item .event-content {
  width: 100%;
}

.version-list-item .event-content .changes {
  font-size: 0.8rem;
  width: 100%;
}

.version-list-item .event-content .changes .change {
  border-radius: 10px;
}

.version-list-item .event-content .changes .change:hover {
  background-color: #b6ffa4 !important;
}

.version-list-item .event-content .changes .change:nth-child(odd){
  /* background-color: #f0f0f0; */
  background-color: #e7fbe3;
}
</style>
